/*
 * Метод для форматирования числа
 *
 * @param {number} value - форматируемое число
 * @param {object} options параметры конфигурации
 * @param {number} options.decimals - длина десятичной дроби
 * @param {string} options.decimalsSeparator - разделитель десятичных знаков
 * @param {string} options.thousandSeparator - разделитель разрядов числа
 * @param {string} options.trailingZeros - дополнение нулями дробной части
 *
 * @returns {string} отформатированное значение
 */
export function formatNumber(value, options = {
  decimals: 2,
  decimalsSeparator: '.',
  thousandSeparator: ' ',
  trailingZeros: false,
}) {
  const {
    decimals,
    decimalsSeparator,
    thousandSeparator,
    trailingZeros,
  } = options;

  // 1. разбить число на целые и дробные части
  const numberAsArray = value.toString().split('.');

  // 2. получить минимальное значение дробной части
  const minimumFractionDigits = numberAsArray.length > 1 && decimals !== 0
    ? (trailingZeros ? decimals : 0) : 0;

  // 3. форматировать значение с учетом минимальной и максимальной длинны дробной части
  const formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits,
    maximumFractionDigits: decimals,
  });

  const numberString = formatter.formatToParts(value).map(({ type, value }) => {
    switch (type) {
      case 'decimal': return decimalsSeparator;
      default: return value;
    }
  }).reduce((string, part) => string + part);

  // 4. произвести замены разделителя тысячных разрядов и разделителя дробной части
  const resultedValue = numberString
    .replace(/,/g, thousandSeparator);

  return resultedValue;
}

export function calcPercent(portion, number) {
  return Math.round(portion / number * 100);
}
